import { useTranslation } from '../../contexts/TranslationContext';
import type { BillingFreePlan } from '../../types/billing';
import type { KnowledgeLawCountry } from '../../services/knowledgeLawCountries';
import { ArrowRight, Check } from '../Icons';
import { BrandButton } from '../ui/BrandButton';
import { SignalTag } from '../ui/SignalTag';
import { PricingFeatureList } from './PricingFeatureList';
import { PricingCard, PricingCardHeader } from './PricingCard';

export function FreePlanCard({ plan, countries = [], onGetStarted, onStartIntent }: {
  plan?: BillingFreePlan;
  countries?: KnowledgeLawCountry[];
  onGetStarted: () => void;
  onStartIntent?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <PricingCard plan="free" onSelect={onGetStarted}>
      <div className="mb-3 flex min-h-8 items-center justify-center">
        <SignalTag tone="secure" className="px-3 py-1 text-xs font-semibold" icon={<Check className="h-4 w-4 shrink-0" aria-hidden="true" />}>
          {t('common.noCardRequired')}
        </SignalTag>
      </div>
      <PricingCardHeader title={t('billing.landing.freeTitle')} price={
          <p className="max-w-full break-words text-5xl font-bold leading-none text-orange-100 sm:text-6xl">0 €</p>
      } />
      <div className="hidden min-h-7 w-full md:block" aria-hidden="true" />
      <PricingFeatureList plan="free" countries={countries} freeCredits={plan?.quotaCredits} />
      <div className="mt-auto w-full pt-8">
        <div className="hidden md:mb-2 md:block md:min-h-4" aria-hidden="true" />
        <BrandButton size="lg" className="min-h-12 w-full justify-center whitespace-normal" onClick={onGetStarted} onFocus={onStartIntent} onPointerEnter={onStartIntent}>
          {t('hero.ctaFreeTrial')}<ArrowRight className="h-4 w-4 shrink-0" />
        </BrandButton>
      </div>
    </PricingCard>
  );
}
